import LocationGroupModal from './LocationGroupModal';

export default LocationGroupModal;
